import { createReducer } from "reduxsauce";

import UIDs from "../../../UIDs";

import ReducerRegister from "../../ReducerRegister";
// import DefaultService from "../../../services/screens/chinesepark/DefaultService";
import ProfileSettingService from "../../../services/screens/me/ProfileSettingService";
import { ActionTypes } from "../../actionTypes/screens/course/RecordSettingActionTypes";
import AsyncActionReducers from "../../AsyncActionReducers";
import UnitService from "../../../services/screens/common/UnitService";

const uid = UIDs.screens.course.recordsetting;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (recordSetting) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });
            UnitService.getRecordConfig(
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response || recordSetting));
                },
                () => {
                    ProfileSettingService.getRecordConfig(
                        response => {
                            dispatch(Actions.loadScreenViewSuccess(response || recordSetting));
                        },
                        error => {
                            console.warn("getRecordConfig error:", error);
                            dispatch(Actions.loadScreenViewSuccess(recordSetting));
                        }
                    );
                }
            );

            /*
            StorageEngine("RECORD_SETTING_STORAGE_KEY")
                .load()
                .then(response => {
                    if (response) {
                        dispatch(Actions.loadScreenViewSuccess(response));
                    }
                    else {
                        dispatch(Actions.loadScreenViewSuccess({}));
                    }
                })
                .catch(response => {
                    console.warn(response);
                    dispatch(Actions.loadScreenViewSuccess({}));
                });
            */

            /*
            RecordSettingService.loadScreenView(
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
            */
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error,
    }),

    saveRecordSettingAsync: (v, cb) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_RECORD_SETTING_ASYNC });
            UnitService.setRecordConfig(
                v,
                response => {
                    dispatch(Actions.saveRecordSettingSuccess(v));
                    if (cb) {
                        cb(true);
                    }
                },
                error => {
                    console.warn("setRecordConfig error:", error);
                    dispatch(Actions.saveRecordSettingFailure(error));
                    if (cb) {
                        cb(false);
                    }
                }
            );

            /*
            StorageEngine("RECORD_SETTING_STORAGE_KEY").save(v);
            if (cb) {
                cb();
            }
            */
        };
    },

    saveRecordSettingSuccess: data => ({
        type: ActionTypes.SAVE_RECORD_SETTING_SUCCESS,
        parentType: ActionTypes.SAVE_RECORD_SETTING_ASYNC,
        postReducer: saveRecordSettingSuccessPostReducer,
        data,
    }),

    saveRecordSettingFailure: error => ({
        type: ActionTypes.SAVE_RECORD_SETTING_FAILURE,
        parentType: ActionTypes.SAVE_RECORD_SETTING_ASYNC,
        error,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    recordSetting: {
        showPinYin: 1,
        showTranslate: 0,
        playExample: 0,
        continuousPlay: 0,
        audioSpeed: 0,
    },
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return {
        ...state,
        recordSetting: { ...state.recordSetting, ...data },
    };
};

const saveRecordSettingSuccessPostReducer = (state, { data }) => {
    return {
        ...state,
        recordSetting: { ...data },
    };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_RECORD_SETTING_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_RECORD_SETTING_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_RECORD_SETTING_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
